import auth from "./auth";
import guest from "./guest";
import checkPermissions from "./checkPermissions";

export default {
    auth,
    guest,
    checkPermissions
}